import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ArrowDownSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.989 2C11.507 2 11.1592 2.3426 11.1592 2.82044V17.2136L11.2571 20.2399L11.7513 20.0588L8.21661 16.2016L5.38905 13.4072C5.24536 13.2677 5.02352 13.1844 4.8059 13.1844C4.34257 13.1844 4 13.5415 4 13.9997C4 14.2215 4.0833 14.4162 4.25927 14.6067L11.3727 21.7168C11.5486 21.9022 11.7621 22 11.989 22C12.2202 22 12.4294 21.9022 12.6054 21.7168L19.723 14.6067C19.899 14.4162 19.9781 14.2215 19.9781 13.9997C19.9781 13.5415 19.6355 13.1844 19.1764 13.1844C18.9545 13.1844 18.7327 13.2677 18.5932 13.4072L15.7615 16.2016L12.2174 20.0588L12.721 20.2399L12.823 17.2136V2.82044C12.823 2.3426 12.4711 2 11.989 2Z"
        fill={color}
      />
    </svg>
  );
};

export { ArrowDownSvg };
